export default __webpack_public_path__ + "static/media/logo.e1bf78c1.png";